import { observer } from "mobx-react-lite"
import { Avatar, Box, CloseButton, type MultiSelectValueProps, rem, Stack, Text } from "@mantine/core"
import { API_URL } from "../../../shared/config"
import type { Instructor } from "../../../shared/types/instructor"

export const SelectorValueComponent = observer(function SelectorValueComponent(
  {
    avatar,
    name,
    position,
    published,
    createdAt,
    _id,
    updatedAt,
    socials,
    label,
    onRemove,
    classNames,
    ...others
  }: MultiSelectValueProps & Instructor) {
  return (
    <div {...others}>
      <Box
        sx={(theme) => ({
          display: "flex",
          cursor: "default",
          alignItems: "center",
          backgroundColor: theme.colors.blue[0],
          border: `${rem(1)} solid ${theme.colors.blue[3]}`,
          padding: "4px 8px 4px 4px",
          borderRadius: theme.radius.lg,
        })}
      >
        <Box mr={10}>
          <Avatar size={40} radius="50%" src={`${API_URL}/media/${avatar}`}/>
        </Box>
        <Stack spacing={4}>
          <Text lh={1} fz={14} fw={500}>{name}</Text>
          <Text maw={180} lineClamp={2} lh={1} fz={12} c="dimmed">{position}</Text>
        </Stack>
        <CloseButton
          color="dark"
          radius="md"
          ml={8}
          onMouseDown={onRemove}
          tabIndex={-1}
        />
      </Box>
    </div>
  )
})
